module.exports = __webpack_public_path__ + "img/so.c1561217.svg";